<template>
  <div>
    <v-toolbar
      class="elevation-1 toolbar-fix"
      flat
      dense
      color="white"
    >
      <v-btn
        v-if="selected.length === 0"
        icon
        @click="toggleAll"
      >
        <v-icon color="grey darken-1">check_box_outline_blank</v-icon>
      </v-btn>

      <v-btn
        v-if="selected.length > 0 && selected.length < carreras.data.length"
        icon
        @click="toggleAll"
      >
        <v-icon color="grey darken-1">indeterminate_check_box</v-icon>
      </v-btn>

      <v-btn
        v-if="selected.length > 0 && selected.length === carreras.data.length"
        icon
        @click="toggleAll"
      >
        <v-icon color="grey darken-1">check_box</v-icon>
      </v-btn>

      <v-btn
        v-if="selected.length === 0"
        icon
        @click="getCarreras"
      >
        <v-icon color="grey darken-1">refresh</v-icon>
      </v-btn>

      <v-btn
        v-if="selected.length > 0"
        icon
        @click="eliminarCarreras"
      >
        <v-icon color="grey darken-1">delete</v-icon>
      </v-btn>

      <v-btn
        v-if="selected.length > 0"
        icon
        @click="copiarTexto"
      >
        <v-icon color="grey darken-1">content_copy</v-icon>
      </v-btn>

      <v-spacer></v-spacer>

      <span color="grey darken-1">{{ carreras.count > 1 ? ((carreras.current_page - 1) * carreras.per_page + 1) : 0 }}-{{ carreras.count ? ((carreras.current_page - 1) * carreras.per_page) + carreras.count : 0 }} de {{ carreras.total ? carreras.total : 0 }}</span>

      <v-btn
        :disabled="carreras.current_page <= 1"
        icon
        @click="getCarrerasPreviousPage"
      >
        <v-icon color="grey darken-1">navigate_before</v-icon>
      </v-btn>

      <v-btn
        :disabled="carreras.current_page >= carreras.last_page"
        icon
        @click="getCarrerasNextPage"
      >
        <v-icon
          color="grey darken-1">navigate_next</v-icon>
      </v-btn>

      <v-btn
        icon
        @click="settingsDialog = true"
      >
        <v-icon color="grey darken-1">settings</v-icon>
      </v-btn>

    </v-toolbar>

    <v-data-table
      v-model="selected"
      :headers="headers"
      :items="carreras.data"
      :pagination.sync="pagination"
      :no-data-text="noDataText"
      :no-results-text="NoResultsText"
      :loading="loading"
      item-key="id"
      hide-actions
      >
      <template slot="headers" slot-scope="props">
        <tr>
          <th></th>
          <th
            v-for="header in props.headers"
            :key="header.text"
            :class="[
              'column sortable',
              pagination.descending ? 'desc' : 'asc',
              header.value === pagination.sortBy ? 'active' : '',
              'text-xs-left',
              header.visibility ? 'hidden-print-only' : 'hidden-screen-only'
            ]"
            @click="changeSort(header.value)"
          >
            {{ header.text }}
            <v-icon small>arrow_upward</v-icon>
          </th>
        </tr>
      </template>
      <template slot="items" slot-scope="props">
        <v-hover>
        <tr
          @click="mostrarCarrera(props.item)"
          slot-scope="{ hover }"
          :class="`elevation-${hover ? 2 : 0}`"
        >
          <td @click.stop="props.selected = !props.selected">
            <v-checkbox
              :input-value="props.selected"
              primary
              hide-details
            ></v-checkbox>
          </td>
          <td :class="[headers[0].visibility ? 'hidden-print-only' : 'hidden-screen-only']">{{ props.item.uuid }}</td>
          <td :class="[headers[1].visibility ? 'hidden-print-only' : 'hidden-screen-only']">{{ props.item.nombre }}</td>
          <td :class="[headers[2].visibility ? 'hidden-print-only' : 'hidden-screen-only']">
            <v-chip v-if="props.item.clave !== null" small color="green" text-color="white">
              <strong>{{ props.item.clave }}</strong>
            </v-chip>
            <v-chip v-else small color="orange" text-color="white">
              <strong>Sin clave</strong>
            </v-chip>
          </td>
          <td :class="[headers[3].visibility ? 'hidden-print-only' : 'hidden-screen-only']">{{ props.item.nivel_de_estudio.nombre }}</td>
          <td :class="[headers[4].visibility ? 'hidden-print-only' : 'hidden-screen-only']">{{ props.item?.campus?.nombre }}</td>
          <div v-if="hover" class="carrera-fix-1">
            <div class="justify-center layout grey lighten-3 carrera-fix-2">
              <v-tooltip bottom>
                <v-btn slot="activator" icon ripple @click.stop="duplicarCarrera(props.item)">
                  <v-icon color="grey darken-1">content_copy</v-icon>
                </v-btn>
                <span>Duplicar en plantel</span>
              </v-tooltip>

              <v-tooltip bottom>
                <v-btn slot="activator" icon ripple @click.stop="eliminarCarrera(props.item)">
                  <v-icon color="grey darken-1">delete</v-icon>
                </v-btn>
                <span>Eliminar</span>
              </v-tooltip>
            </div>
          </div>
        </tr>
        </v-hover>
      </template>
    </v-data-table>

    <v-dialog
      v-model="settingsDialog"
      persistent
      max-width="400px"
      :fullscreen="$vuetify.breakpoint.xsOnly"
    >
      <v-card>
        <v-card-title>
          <span class="headline">Configuración</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-list>
              <v-subheader>
                Número de filas por página
              </v-subheader>

              <v-slider
                v-model="pagination.rowsPerPage"
                thumb-label="always"
                step="10"
                :thumb-size="24"
                :min="10"
                :max="100"
                ticks
                tick-size="2"
              ></v-slider>

              <v-subheader>
                Columnas a mostrar
              </v-subheader>
              
              <v-list-tile
                v-for="(header, index) in headers"
                :key="index"
              >
                <v-list-tile-action>
                  <v-switch
                    v-model="header.visibility"
                    color="primary"
                  ></v-switch>
                </v-list-tile-action>
                <v-list-tile-title>{{ header.text }}</v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary darken-1" flat @click="settingsDialog = false">Cancelar</v-btn>
          <v-btn color="primary darken-1" flat @click="aplicarConfiguracion">Aplicar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
import { api } from "~/config";
import Form from '~/mixins/form'

export default {
  mixins: [Form],

  data: () => ({
    loading: false,

    noDataText: "No hay carreras registradas",
    NoResultsText: "No hay carreras que coincidan con tus criterios",

    selected: [],

    headers: [
      { text: "ID", value: "uuid", visibility: true },
      { text: "Nombre", value: "nombre" , visibility: true },
      { text: "Clave DGP", value: "clave", visibility: true },
      { text: "Nivel de Estudio", value: "nivel_de_estudio.nombre", visibility: false },
      { text: "Campus", value: "campus.nombre", visibility: true },
    ],

    settingsDialog: false,
    
    pagination: {
      rowsPerPage: 10,
      sortBy: 'uuid'
    },

    carreras: {},
  }),

  computed: {
    ...mapGetters({
      live_mode: "auth/live_mode",
      busqueda: "auth/busqueda"
    })
  },

  watch: {
    live_mode(val) {
      if (val !== undefined) {
        this.$store.dispatch('auth/guardarBusqueda', { busqueda: null })
        this.$router.push({ name: 'carrera' })
        this.getCarreras()
      }
    },

    busqueda(val) {
      if (val) {
        this.$router.replace('#buscar/' + val)
      } else {
        this.$router.replace('')
      }
      this.getCarreras()
    }
  },

  methods: {
    toggleAll () {
      if (this.selected.length) this.selected = []
      else this.selected = this.carreras.data.slice()
    },
    
    changeSort (column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending
      } else {
        this.pagination.sortBy = column
        this.pagination.descending = false
      }
    },

    getCarreras() {
      this.loading = true
      axios
        .get(api.path("carreras"),  {
          params: {
            page_size: this.pagination.rowsPerPage,
            q: this.busqueda
          }
        })
        .then(res => {
          this.carreras = res.data
        })
        .catch(err => {
          this.handleErrors(err.response.data.errors);
        })
        .then(() => {
          this.loading = false
        });
    },

    getCarrerasPreviousPage() {
      this.loading = true
      axios
        .get(api.path("carreras"), {
          params: {
            page_size: this.pagination.rowsPerPage,
            page: this.carreras.current_page - 1,
            q: this.busqueda
          }
        })
        .then(res => {
          this.carreras = res.data
          this.selected = []
        })
        .catch(err => {
          this.handleErrors(err.response.data.errors);
        })
        .then(() => {
          this.loading = false
        });
    },

    getCarrerasNextPage() {
      this.loading = true
      axios
        .get(api.path("carreras"), {
          params: {
            page_size: this.pagination.rowsPerPage,
            page: this.carreras.current_page + 1,
            q: this.busqueda
          }
        })
        .then(res => {
          this.carreras = res.data
          this.selected = []
        })
        .catch(err => {
          this.handleErrors(err.response.data.errors);
        })
        .then(() => {
          this.loading = false
        });
    },

    eliminarCarrera(val) {
      this.$confirm("¿Desea eliminar esta carrera?").then(
        res => {
          if (res) {
            axios
              .delete(api.path("carreras.single", { id: val.id }))
              .then(res => {
                this.$toast.success("Carrera eliminada correctamente.")
                this.selected = []
                this.getCarreras()
              })
              .catch(err => {
                this.$toast.error("No se puede eliminar la carrera.")
                this.handleErrors(err.response.data.errors)
              })
              .then(() => {})
          }
        }
      )
    },

    eliminarCarreras() {
      this.$confirm("¿Desea eliminar las carreras seleccionadas?").then(
        res => {
          if (res) {

            let ids = []

            this.selected.forEach(function(val) {
              ids.push(val.id)
            })

            axios
              .delete(api.path("carreras"), {
                params: {
                  ids: ids.join()
                }
              })
              .then(res => {
                this.$toast.success("Carreras eliminadas correctamente.")
                this.selected = []
                this.getCarreras()
              })
              .catch(err => {
                this.$toast.error("No se pueden eliminar las carreras.")
                this.handleErrors(err.response.data.errors)
              })
              .then(() => {})
          }
        }
      )
    },

    duplicarCarrera(val) {
      this.$router.push({ name: 'carrera-duplicar', params: { id: val.id } })
    },

    copiarTexto() {
      let data = ''

      this.selected.forEach(function(val) {
        data = data + val.uuid + '\t'
        data = data + val.nombre + '\t'
        data = data + val.clave + '\t'
        data = data + val.nivel_de_estudio.nombre + '\n'
      })

      let me = this
      this.$copyText(data).then(function (e) {
        me.$toast.success("Datos copiados al portapapeles.")
      }, function (e) {
        me.$toast.success("No se puede copiar los datos al portapapeles.")
      })
    },

    mostrarCarrera(val) {
      this.$router.push({ name: 'carrera-mostrar', params: { id: val.id } })
    },

    aplicarConfiguracion() {
      this.settingsDialog = false
      this.getCarreras()
      localStorage.setItem('carrera.pagination', JSON.stringify({
        descending: this.pagination.descending,
        rowsPerPage: this.pagination.rowsPerPage,
        sortBy: this.pagination.sortBy
      }))
      localStorage.setItem('carrera.headers', JSON.stringify(this.headers))
    },
  },

  mounted() {
    if (localStorage.hasOwnProperty('carrera.pagination')) {
      this.pagination = JSON.parse(localStorage.getItem('carrera.pagination'))
    }

    if (localStorage.hasOwnProperty('carrera.headers')) {
      this.headers = JSON.parse(localStorage.getItem('carrera.headers'))
    }

    let tab = this.$route.fullPath.replace(this.$route.path, '').split('/')

    if (tab[0] === '#buscar') {
      let busqueda = decodeURI( tab[1] )
      this.$store.dispatch('auth/guardarBusqueda', { busqueda: busqueda })
    } else {
      if (this.busqueda) {
        this.$store.dispatch('auth/guardarBusqueda', { busqueda: null })
      }
    }
    
    this.getCarreras()
  }
}
</script>

<style>
	.toolbar-fix {
    position: sticky !important;
    z-index: 2 !important;
    top: 48px !important;
	}

  .table-fix {
    padding-top: 48px !important;
	}

  .carrera-fix-1 {
    position: relative !important;
	}

  .carrera-fix-2 {
    position: absolute !important;
    z-index: 1 !important;
    left: -104px !important;
    top: 1px !important;
    height: 47px !important;
	}
</style>
